<template>
  <div class="redundant">
    <!-- 地址 -->
    <v-address
      @change="addressSave"
      v-if="item.attr === 'address'"
      :attrValue="form.address">
    </v-address>
    <!-- 供应商电话 -->
    <v-phone
      v-else-if="item.attr === 'phone'"
      @numChange="phoneSave"
      :attrValue.sync="form.phone">
    </v-phone>
    <!-- 负责人 -->
    <template v-else-if="item.attr === 'managerId'">
      <v-manager
        :item="item"
        :form="form">
      </v-manager>
    </template>
    <!-- 供货产品 -->
    <template v-else-if="item.attr === 'productList'">
      <div class="products">
        <div class="v-area">
          <template v-if="form[item.attr] && form[item.attr].length">{{form[item.attr] | productLen}}</template>
          <template v-else>暂无关联产品</template>
        </div>
        <span class="add-btn" @click="emitParent">选择</span>
      </div>
    </template>
    <el-input
      v-else
      v-model="form[item.attr]"
      disabled>
    </el-input>
  </div>
</template>

<script>
import Vue from 'vue'
import vAddress from '../address'
import vPhone from '../phone'
import vManager from '../manager'

export default {
  props: ['item', 'form'],
  data () {
    return {
    }
  },
  methods: {
    addressSave (arr) {
      Vue.set(this.form, 'address', arr)
    },
    phoneSave (arr) {
      Vue.set(this.form, 'phone', arr)
    },
    emitParent () {
      this.$emit('showProduct', 'add')
    }
  },
  filters: {
    productLen (arr) {
      return `已关联${arr.length}种产品`
    }
  },
  components: {
    vAddress,
    vPhone,
    vManager
  }
}
</script>
<style lang="less" scoped>
  @import '../../../assets/less/fieldtype-products.less';
</style>



// WEBPACK FOOTER //
// index.vue?1f185b53